import { KalturaHouseholdDevice } from '@kaltura-ott/ott-client-types/api/types';

/**
 * List of possible values
 * @category Basic KUX Configuration
 */
export enum HouseholdDeviceGetErrorCodeEnum {
  ExceededLimit = '1001',
  DeviceTypeNotAllowed = '1002',
  DeviceNotInDomain = '1003',
  DeviceNotExists = '1019',
  DeviceRemoved = '50027',
  InvalidKs = '500015',
  ExpiredKs = '500016',
}

/**
 * List of possible values for getHouseholdQuota errors
 * @category Basic KUX Configuration
 */

export enum QuotaStatusEnum {
  NpvrLimitedQuota = 2,
  NpvrUnlimitedQuota = 3,
  NpvrServiceNotAllowed = 1,
}

export enum HouseholdQuotaErrorCodeEnum {
  ServiceNotAllowed = '3003',
  AccountCdvrNotEnabled = '3033',
}

export enum HouseholdDeviceRemoveErrorCodeEnum {
  LimitationPeriod = '1014',
}

export interface HouseholdStreamingDevice extends KalturaHouseholdDevice {
  isStreaming: boolean;
}

export interface HouseholdStreamingDevices {
  totalCount: number;
  objects: HouseholdStreamingDevice[];
}

export interface HouseholdDevice extends HouseholdStreamingDevice {
  deviceBrandName: string;
}

export const HouseholdMigrationErrorMessage = 'Household not migrated';
